import { useQuery } from '@tanstack/react-query';

import { getMissingAccessSources, practiceMemberOptions } from '@/entities/practice-member';
import { subscriptionMeOptions, TRIAL_EARLY_ADOPTERS_PLAN_CODE } from '@/entities/subscription';

import { type SettingsNavGroup, settingsNavGroups } from './settings-nav-groups';

type SettingsNavItem = SettingsNavGroup['items'][number];

export function useSettingsNavGroups() {
    const { data: subscription } = useQuery(subscriptionMeOptions());
    const { data: practiceMember } = useQuery(practiceMemberOptions());

    const hidesPlanBilling = subscription?.planCode === TRIAL_EARLY_ADOPTERS_PLAN_CODE;

    function isVisible(item: SettingsNavItem) {
        if (hidesPlanBilling && item.to === '/settings/plan-billing') {
            return false;
        }
        if (!item.requiredAccessSources) {
            return true;
        }
        return (
            practiceMember !== undefined &&
            getMissingAccessSources(practiceMember.accessSources, item.requiredAccessSources)
                .length === 0
        );
    }

    return settingsNavGroups
        .map((group) => ({ ...group, items: group.items.filter(isVisible) }))
        .filter((group) => group.items.length > 0);
}
